import React from "react";

const Location = ({ address, city, province, zip }) => {
  const src = `https://www.google.com/maps/embed/v1/place?key=AIzaSyCgImsLUsK-v_7T9gytx9fmfHyYL4HDnSQ&q=${address},${city},${province},${zip}`;

  return (
    <div className="location_wrapper">
      <iframe
        src={src}
        width="100%"
        height="450"
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Location;
